module.exports = __webpack_public_path__ + "544e90699a7b097cfdb6fee52a1e755c.svg";